import TEXTS from '../controller/TextVariables';
import { InterfaceContext } from '../model/InterfaceProvider';
import { useContext } from 'react';
import { Tooltip, StandardTooltipWindow } from './Tooltip';

export default function ResetButton() {
    const { doReset, setSearch, tab, theme } = useContext(InterfaceContext);
    const { label, tooltip, resetTooltip } = TEXTS.controls.reset_button;
    const id = 'reset-tip';

    const onBtnClick = () => {
        doReset();
    };
    return (
        <div id="resetBtn" className="field right">
            <Tooltip id={id} tooltip={tooltip} window={<StandardTooltipWindow id={id} text={tooltip} />}>
                <button className="btn icon-undo" id="start-over" onClick={onBtnClick}>
                    {label}
                </button>
            </Tooltip>
            {tab.slug === 'data' && theme.slug != 'overall_svi' && (
                <Tooltip id={id + '2'} tooltip={resetTooltip} window={<StandardTooltipWindow id={id + '2'} text={resetTooltip} />}>
                    <div className="reset icon-info"></div>
                </Tooltip>
            )}
        </div>
    );
}
